import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {UserErrorsFactory} from '../../user/Errors/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import {DraftRepositoriesFactory} from '../Repositories/factory.js'

export class RenewAdPublisherUseCase extends UseCase {
  #getCurrentUserService
  #httpRepository
  #userNotLoggedInUserError

  constructor({config}) {
    super()

    this.#getCurrentUserService = UserServicesFactory.getCurrentUserService({config})
    this.#httpRepository = DraftRepositoriesFactory.hTTPDraftRepository({config})
    this.#userNotLoggedInUserError = UserErrorsFactory.userNotLoggedInUserError
  }

  static create({config}) {
    return new RenewAdPublisherUseCase({config})
  }

  @tracer({metric: 'RenewAdPublisherUseCase#execute'})
  @AsyncInlineError()
  async execute({adId}) {
    const userEntity = await this.#getCurrentUserService.execute()

    if (!userEntity) {
      return Promise.reject(
        this.#userNotLoggedInUserError({
          message: '[RenewAdPublisherUseCase#execute] User not logged in'
        })
      )
    }

    const [error, response] = await this.#httpRepository.renewAd({adId, userEntity})

    if (error) return Promise.reject(error)

    return response
  }
}

export const factory = RenewAdPublisherUseCase.create
